(function(){
  // --- Hook de window.fetch ---
  const _fetch = window.fetch;
  window.fetch = async function(input, init){
    const res = await _fetch.apply(this, arguments);
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || '';
      const method = (init && init.method) || (input && input.method) || 'GET';
      if (/\/cart\/add(\.js)?/i.test(url) && String(method).toUpperCase() !== 'GET' && res && res.ok) {
        setTimeout(()=> window.ZKCart && window.ZKCart.refreshAndShow && window.ZKCart.refreshAndShow(), 0);
      }
    } catch(_) {}
    return res;
  };

  // --- Hook de XMLHttpRequest ---
  const _open = XMLHttpRequest.prototype.open;
  const _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url){
    this.__zk_method = method;
    this.__zk_url = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function(){
    this.addEventListener('loadend', function(){
      try {
        const ok = this.status >= 200 && this.status < 300;
        if (ok && /\/cart\/add(\.js)?/i.test(this.__zk_url || '') && String(this.__zk_method).toUpperCase() !== 'GET') {
          setTimeout(()=> window.ZKCart && window.ZKCart.refreshAndShow && window.ZKCart.refreshAndShow(), 0);
        }
      } catch(_) {}
    });
    return _send.apply(this, arguments);
  };
})();
